module.exports = __webpack_public_path__ + "static/media/sagamihara_button_gochirameru.70d8f480.png";